import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/come-funziona", label: "Come Funziona" },
  { to: "/perche-farlo", label: "Perché Farlo" },
  { to: "/trasparenza", label: "Trasparenza" },
];

export function MarketingNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0A1128]/80 backdrop-blur-lg border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}
              className="text-sm text-white/70 hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link to={user.role === "admin" || user.role === "manager" ? "/admin" : "/dashboard"}
              data-testid="nav-dashboard-btn"
              className="text-sm font-medium text-white/90 hover:text-white px-4 py-2">
              La mia area
            </Link>
          ) : (
            <Link to="/accedi" data-testid="nav-login-btn"
              className="text-sm font-medium text-white/90 hover:text-white px-4 py-2">
              Accedi
            </Link>
          )}
          <button onClick={() => navigate("/segnala")} data-testid="nav-segnala-btn"
            className="btn-gold rounded-full px-5 py-2.5 text-sm font-semibold">
            Segnala un immobile
          </button>
        </div>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#0A1128] border-t border-white/10 px-5 py-4 space-y-3">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block text-white/80 py-2">{l.label}</Link>
          ))}
          <Link to={user ? "/dashboard" : "/accedi"} onClick={() => setOpen(false)}
            className="block text-white/80 py-2">{user ? "La mia area" : "Accedi"}</Link>
          <button onClick={() => { setOpen(false); navigate("/segnala"); }}
            className="btn-gold rounded-full px-5 py-3 text-sm font-semibold w-full">
            Segnala un immobile
          </button>
        </div>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-[#0A1128] border-t border-white/10 text-white/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            La piattaforma PropTech che trasforma una segnalazione in un'opportunità
            tracciabile, fino al risultato e al riconoscimento economico.
          </p>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-3">Piattaforma</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/come-funziona" className="hover:text-white">Come Funziona</Link></li>
            <li><Link to="/perche-farlo" className="hover:text-white">Perché Farlo</Link></li>
            <li><Link to="/trasparenza" className="hover:text-white">Trasparenza</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-3">Account</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/accedi" className="hover:text-white">Accedi</Link></li>
            <li><Link to="/registrati" className="hover:text-white">Registrati</Link></li>
            <li><Link to="/segnala" className="hover:text-white">Segnala un immobile</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Pistone Parla Chiaro. L'attività del segnalatore è distinta dalla mediazione immobiliare professionale.
      </div>
    </footer>
  );
}
